import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton, TableCell } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import EmailIcon from '@mui/icons-material/Email';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { connect } from 'react-redux';
import Swal from "sweetalert2";

import DefaultTable from '../../../components/Table';
import appConfig from '../../../config/appConfig';
import * as footerActions from '../../../store/actions/footer';
import CreateFooterConfiguration from './CreateFooterConfiguration';
import EditFooterConfiguration from './EditFooterConfiguration';

const ViewFooterConfigurations = ({ fetchFooterConfigs, 
    resetEditFooterConfigData, resetCreateFooterConfigData, footerConfigs, deleteFooter }) => {

    const [activeMode, setActiveMode] = useState('list');
    const [footerConfigsData, setFooterConfigsData] = useState();
    const [paginationFooter, setPaginationFooter] = useState({ limit: 10, offset: 1 });
    const [selectedRowFooter, setSelectedRowFooter] = useState();
    const [isFooterConfigDeleted, setIsFooterConfigDeleted] = useState(false);

    useEffect(async () => {
        await fetchFooterConfigs(paginationFooter.limit, paginationFooter.offset);
    }, []);

    useEffect(() => {
        fetchFooterConfigs(paginationFooter.limit, paginationFooter.offset);
    }, [paginationFooter, footerConfigs?.editFooterData, footerConfigs?.createFooterData])

    useEffect(() => {
        setFooterConfigsData(footerConfigs?.footers?.footers);
    }, [footerConfigs])

    useEffect(() => {
            if (footerConfigs?.deleteFooterData?.data?.status === 1 && isFooterConfigDeleted) {
                setIsFooterConfigDeleted(false);
                Swal.fire({
                icon: "success",
                button: false,
                showConfirmButton: false,
                timer: 2000,
                text: "Footer Configuration deleted successfully",
                });
                setTimeout(() => {
                fetchFooterConfigs(paginationFooter.limit, 1,'','');
                }, 2000);
            }else if(footerConfigs?.deleteFooterData?.data?.status === 0 && isFooterConfigDeleted){
                setIsFooterConfigDeleted(false);
                Swal.fire({
                icon: "error",
                button: false,
                showConfirmButton: false,
                timer: 2000,
                text: "Error, please try again later",
                });
            }
        }, [JSON.stringify(footerConfigs?.deleteFooterData)])

    const handlePaginationFooter = (limit, offset) => {
        setPaginationFooter({ limit, offset });
    }

    // const handleDefaultFooter = (row) => {
    //     console.log('Set payload and Update call', row);
    // }

    const handleEditFooter = (row) => {
        resetEditFooterConfigData();
        setActiveMode('edit');
        setSelectedRowFooter(row);
    }

    const handleDeleteFooter = (row) => {
        const swalWithCustompButtons = Swal.mixin({
                        customClass: {
                        confirmButton: 'custom-ok-button',
                        cancelButton: 'custom-cancel-button'
                        },
                        buttonsStyling: false
                    })
                
                    swalWithCustompButtons.fire({
                        title: "",
                        html: `Delete Footer Configuration? <br/> <span style='font-size: 14px'}}> All Email configuration associated with this Footer will be replaced by Default Footer.</span>`,
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Cancel',
                        confirmButtonText: 'Delete',
                        reverseButtons: true
                    }).then((result) => {
                        setIsFooterConfigDeleted(false);
                        if (result.isConfirmed) {
                        setIsFooterConfigDeleted(true);
                        deleteFooter(row);
                        } else {
                        setIsFooterConfigDeleted(false);
                        }
                    })
    }

    const renderCellsFooter = (row) => {
        return <>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.defaultConfigFlag ? `${row.name}(Default)` : row.name}
            </TableCell>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.code}
            </TableCell>
        </>
    }

    const renderActionButtonFooter = (row) => {
        return <div className='display-flex'>
            {/* <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px' }}
                title={row?.isDefault ? 'Default Footer Configuration' : 'Set as default'}
                aria-label={row?.isDefault ? 'default footer configuration' : 'set as default footer configuration'}
                size="small"
                onClick={() => {
                    handleDefaultFooter(row);
                }}
            >
                {
                    row?.isDefault ?
                        <EmailIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                        :
                        <MailOutlineIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                }
            </IconButton> */}
            <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Edit Footer Configuration'
                aria-label="edit footer configuration"
                size="small"
                onClick={() => {
                    handleEditFooter(row);
                }}
            >
                <ModeEditOutlineOutlinedIcon />
            </IconButton>
            {!row?.defaultConfigFlag && <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Delete Footer Configuration'
                aria-label="delete footer configuration"
                size="small"
                onClick={() => {
                    handleDeleteFooter(row);
                }}
            >
                <DeleteForeverOutlinedIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
            </IconButton>}
        </div>
    }

    return <div>
        <Grid item md={12} xl={12} lg={12} sm={12} sx={{ mb: 1 }}>
            {
                activeMode === 'list' && 
                <DefaultTable
                    title='Footer Configurations'
                    handlePagination={handlePaginationFooter}
                    headers={[
                        {
                            name: 'Name', sortEnabled: false
                        },
                        {
                            name: 'Code', sortEnabled: false
                        }
                    ]}
                    hasAction
                    renderActionButton={renderActionButtonFooter}
                    data={footerConfigsData}
                    totalCount={footerConfigsData?.length}
                    currentPage={paginationFooter.offset}
                    currentLimit={paginationFooter.limit}
                    renderCustomCells
                    renderCells={renderCellsFooter}
                    isTableHeaderEnabled
                    tableHeaderCallback={() => { resetCreateFooterConfigData(); setActiveMode('create') }}
                    tableHeaderButtonText='Create Footer Configurations'
                />
            }
            {
                activeMode === 'create' && 
                <CreateFooterConfiguration 
                    showFooterConfigurations={() => setActiveMode('list')} 
                />
            }
            {
                activeMode === 'edit' && 
                <EditFooterConfiguration 
                    footerConfig={selectedRowFooter} 
                    showFooterConfigurations={() => setActiveMode('list')} 
                />
            }
        </Grid>
    </div>
}

ViewFooterConfigurations.propTypes = {
    footerConfigs: PropTypes.object.isRequired,
    fetchFooterConfigs: PropTypes.func.isRequired,
    deleteFooter: PropTypes.func.isRequired,    
    resetEditFooterConfigData: PropTypes.func.isRequired,
    resetCreateFooterConfigData: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
    footerConfigs: state.footer
})

const mapDispatchToProps = (dispatch) => {
    return {
        fetchFooterConfigs: (limit, page) => dispatch(footerActions.getFooterList(limit, page)),
        deleteFooter: (data) => dispatch(footerActions.deleteFooter(data)),
        resetEditFooterConfigData: () => dispatch(footerActions.resetEditFooterConfigData()),
        resetCreateFooterConfigData: () => dispatch(footerActions.resetCreateFooterConfigData()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewFooterConfigurations);